const STATUS_STYLES = {
  pending: "bg-[#F59E0B]/10 text-[#F59E0B]",
  approved: "bg-[#22C55E]/10 text-[#22C55E]",
  verified: "bg-[#22C55E]/10 text-[#22C55E]",
  rejected: "bg-[#EF4444]/10 text-[#EF4444]",
  active: "bg-[#22C55E]/10 text-[#22C55E]",
  paused: "bg-[#F59E0B]/10 text-[#F59E0B]",
  sold: "bg-[#8B5CF6]/10 text-[#8B5CF6]",
  removed: "bg-[#EF4444]/10 text-[#EF4444]",
};

export const StatusBadge = ({ status }) => (
  <span
    className={`px-2 py-0.5 text-xs rounded-full capitalize ${
      STATUS_STYLES[status] || "bg-[#27272A] text-[#A1A1AA]"
    }`}
  >
    {status}
  </span>
);
